import React, { FC } from 'react';

import { Badge as BadgeUI } from './styles';

export interface IBadge {
  title: string;
  color: string;
  className?: string;
  isCardView?: boolean;
  textColor?: string;
  borderColor?: string;
}

export const Badge: FC<IBadge> = ({
  title,
  color,
  className = 'badge-ui',
  isCardView = false,
  textColor = '',
  borderColor = '',
}) => (
  <BadgeUI className={className} color={color} isCardView={isCardView} textColor={textColor} borderColor={borderColor}>
    {title}
  </BadgeUI>
);
